import { useEffect, useRef } from 'react';
import { useAuth } from '../../../store/auth';
import { DashboardRegisteringBusinessPage } from './DashboardRegisteringBusinessPage';
import { DashboardRegisteringCompanyPage } from './DashboardRegisteringCompanyPage';
import { DashboardRegisteringDirectorsPage } from './DashboardRegisteringDirectors';
import { DashboardRegisteringShareholdersPage } from './DashboardRegisteringShareholders';
import { Steps, useRegisteringStore } from './store/registering.store';
import DashboardRegisteringMembersPage from './DashboardRegisteringMembers';

const DashboardRegistering = () => {
  const { company, user } = useAuth();
  const { step, setStep } = useRegisteringStore();

  const isDelaware = user?.jurisdiction?.description === 'Delaware';
  const lastCompanyStatusRef = useRef<string | undefined>(undefined);
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    // Só atualiza o step se o status da empresa realmente mudou
    const currentStatus = company?.status;
    
    // Na primeira renderização, inicializa o step
    if (!hasInitializedRef.current && currentStatus) {
      hasInitializedRef.current = true;
      lastCompanyStatusRef.current = currentStatus;
      const adjustedStep =
        isDelaware && currentStatus === Steps.Shareholders ? Steps.Members : ((currentStatus || '') as Steps);
      setStep(adjustedStep);
      return;
    }

    // Se o status não mudou, não faz nada (evita resetar o step ao trocar idioma)
    if (lastCompanyStatusRef.current === currentStatus) {
      return;
    }

    // Só atualiza se o status realmente mudou
    if (currentStatus && currentStatus !== lastCompanyStatusRef.current) {
      lastCompanyStatusRef.current = currentStatus;
      const adjustedStep =
        isDelaware && currentStatus === Steps.Shareholders ? Steps.Members : ((currentStatus || '') as Steps);
      setStep(adjustedStep);
    }
  }, [company?.status, isDelaware, setStep]);

  if (step === Steps.Members) {
    return <DashboardRegisteringMembersPage />;
  }

  if (step === Steps.Directors) {
    return <DashboardRegisteringDirectorsPage />;
  }

  if (step === Steps.Shareholders) {
    return <DashboardRegisteringShareholdersPage />;
  }

  if (step === Steps.Business) {
    return <DashboardRegisteringBusinessPage />;
  }

  return <DashboardRegisteringCompanyPage />;
};

export { DashboardRegistering };
